'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _utils = require('./../utils');

var _transport = require('./transport');

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.pixel)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.beacon)(url).catch(function () {
      return (0, _transport.pixel)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return fetch(url, { credentials: 'include' }).then(function (response) {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response;
    });
  };
}
//# sourceMappingURL=publishers.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/lib/publishers.js
// module id = 1124
// module chunks = 15 16 17 18 19